module.exports = __webpack_public_path__ + "static/media/grimace.adaea510.svg";